import {svgIconWrapper} from '../svg-icon-wrapper';

import SeamlessRegular from './seamless-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SeamlessRegular {...props} />;
}

SvgComponent.iconName = 'seamlessRegular';

export const SeamlessRegularIcon = svgIconWrapper(SvgComponent);
